import { createSelector } from 'reselect';

const messagesSelect = (state) => state.authorization;

export const selectLogout = createSelector(messagesSelect, ({ logout }) => logout);
